// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo__background{fill:#252837}@media(prefers-color-scheme:dark){.logo__background{fill:var(--mint)}.logo__mark{fill:var(--dark)!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
